import {
  CSSProperties,
  ChangeEventHandler,
  PropsWithChildren,
  ReactNode,
} from "react";

function TextAreaField({
  initialValue,
  label,
  name,
  id,
  labelStyle,
  labelClassName,
  inputStyle,
  inputClassName,
  placeholder,
  disable,
  onChange,
}: PropsWithChildren<{
  disable?: boolean;
  initialValue?: string;
  label?: string | ReactNode;
  name?: string;
  id?: string;
  labelClassName?: string;
  inputClassName?: string;
  labelStyle?: CSSProperties;
  inputStyle?: CSSProperties;
  onChange: ChangeEventHandler<HTMLTextAreaElement> | undefined;
  placeholder?: string;
}>) {
  return (
    <div style={{ ...labelStyle }} className={labelClassName}>
      <div>
        <label htmlFor={id}>
          <span>{label}</span>
        </label>
      </div>
      <div>
        <textarea
          disabled={disable}
          placeholder={placeholder}
          onChange={onChange}
          id={id}
          defaultValue={initialValue}
          name={name}
          style={{ ...inputStyle }}
          className={inputClassName}
        />
      </div>
    </div>
  );
}

export default TextAreaField;
